module.exports = __webpack_public_path__ + "static/media/biteship-lalamove.bc77c192.png";